<form [formGroup]="form" class="flex mx-auto col-10" (ngSubmit)="onSubmit()">
	<div class="flex flex-column gap-2 ">
		<main class="grid formgrid">
			<div class="field col-12 mb-4  ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-user" ></p-inputIcon>
          <input pInputText formControlName="primerNombre" id="primerNombre" type="text"
                 class="w-full container-input"
                 [placeholder]="'components.app-authentication-manager.register-form.primerNombre' | translate"/>
        </p-iconField>
				<ng-container *ngIf="form.get('primerNombre')?.invalid && form.get('primerNombre')?.touched">
					<app-form-group-error-message [control]="form.get('primerNombre')"/>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-user"></p-inputIcon>
          <input pInputText formControlName="segundoNombre"
                 [placeholder]="'components.app-authentication-manager.register-form.segundoNombre'| translate"
                 id="segundoNombre" type="text" class=" w-full container-input"/>
        </p-iconField>
				<ng-container *ngIf="form.get('segundoNombre')?.invalid && form.get('segundoNombre')?.touched">
					<app-form-group-error-message [control]="form.get('segundoNombre')"/>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-user"></p-inputIcon>
          <input pInputText formControlName="primerApellido" id="primerApellido" type="text"
                 [placeholder]="'components.app-authentication-manager.register-form.primerApellido' | translate"
                 class=" w-full container-input"/>
        </p-iconField>
				<ng-container *ngIf="form.get('primerApellido')?.invalid && form.get('primerApellido')?.touched">
					<app-form-group-error-message [control]="form.get('primerApellido')"/>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-user"></p-inputIcon>
          <input pInputText formControlName="segundoApellido"
                 [placeholder]="'components.app-authentication-manager.register-form.segundoApellido' | translate"
                 type="text" class=" w-full container-input"/>
        </p-iconField>
				<ng-container *ngIf="form.get('segundoApellido')?.invalid && form.get('segundoApellido')?.touched">
					<app-form-group-error-message [control]="form.get('segundoApellido')"/>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-phone"></p-inputIcon>
          <input pInputText formControlName="telefono" id="telefono"
                 [placeholder]="'components.app-authentication-manager.register-form.telefono' |
               translate"
                 type="text" class="container-input w-full"/>
        </p-iconField>
				<ng-container *ngIf="form.get('telefono')?.invalid && form.get('telefono')?.touched">
					<app-form-group-error-message [control]="form.get('telefono')"/>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-envelope"></p-inputIcon>
          <input pInputText formControlName="correoElectronico" id="correoElectronico"
                 [placeholder]="'components.app-authentication-manager.register-form.correoElectronico' | translate"
                 type="text" class="container-input w-full"/>
        </p-iconField>
				<ng-container *ngIf="form.get('correoElectronico')?.invalid && form.get('correoElectronico')?.touched">
					<app-form-group-error-message [control]="form.get('correoElectronico')"/>
				</ng-container>
			</div>
			<div class="field col-12 ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-address-book"></p-inputIcon>
          <input pInputText formControlName="direccion" id="direccion"
                 [placeholder]="'components.app-authentication-manager.register-form.direccion' | translate"
                 type="text" class=" w-full container-input"/>
        </p-iconField>
				<ng-container *ngIf="form.get('direccion')?.invalid && form.get('direccion')?.touched">
					<app-form-group-error-message [control]="form.get('direccion')"/>
				</ng-container>
			</div>
			<div class="field col-12   ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-id-card z-1"></p-inputIcon>
          <p-dropdown [options]="tipoIdentificaciones" formControlName="tipoIdentificacionId" appendTo="body"
                      [placeholder]="'components.app-authentication-manager.register-form.tipoIdentificacionId' | translate"
                      optionLabel="abreviatura" optionValue="id" autoWidth="false" [style]="{'width':'100%'}"
                      class="container-dropdown-input">
          </p-dropdown>
        </p-iconField>
				<ng-container *ngIf="form.get('tipoIdentificacionId')?.invalid && form.get('tipoIdentificacionId')?.dirty">
					<app-form-group-error-message [control]="form.get('tipoIdentificacionId')"/>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-hashtag"></p-inputIcon>
          <p-inputNumber formControlName="identificacion" id="identificacion"
                         [placeholder]="'components.app-authentication-manager.register-form.identificacion' | translate"
                         styleClass="w-full" inputStyleClass="container-input"
                         class="w-full" [useGrouping]="false"></p-inputNumber>
        </p-iconField>
				<ng-container *ngIf="form.get('identificacion')?.invalid && form.get('identificacion')?.touched">
					<app-form-group-error-message [control]="form.get('identificacion')"/>
				</ng-container>
			</div>

			<div class="field col-12 mb-4"  >
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-globe z-1"></p-inputIcon>
          <p-dropdown [options]="paises" formControlName="paisExpedicionId" appendTo="body"  (onChange)="onPaisChange($event)"
                      [placeholder]="'components.app-authentication-manager.register-form.paisExpedicionId' | translate"
                      optionLabel="descripcion" autoWidth="false" [style]="{'width':'100%'}" [filter]="true" [overlayOptions]=""
                      class="container-dropdown-input" >
          </p-dropdown>
        </p-iconField>

				<ng-container *ngIf="form.get('paisExpedicionId')?.invalid && form.get('paisExpedicionId')?.dirty">
					<app-form-group-error-message [control]="form.get('paisExpedicionId')"/>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  " *ngIf="isOtroPaisExpedicion">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-globe"></p-inputIcon>
				<input pInputText formControlName="otroPaisExpedicion" id="otroPaisExpedicion"
               [placeholder]="'components.app-authentication-manager.register-form.otroPaisExpedicion' | translate"
               type="text" class=" w-full container-input" />
        </p-iconField>
				<ng-container *ngIf="form.get('otroPaisExpedicion')?.invalid && form.get('otroPaisExpedicion')?.touched">
					<app-form-group-error-message [control]="form.get('otroPaisExpedicion')"/>
				</ng-container>
			</div>

			<div class="field col-12 mb-4  " *ngIf="!isOtroPaisExpedicion">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-map z-1"></p-inputIcon>
          <p-dropdown [options]="departamentos" formControlName="departamentoExpedicionId" appendTo="body"
                      (onChange)="onDepartamentoChange($event)" class="container-dropdown-input"
                      [placeholder]="'components.app-authentication-manager.register-form.departamentoExpedicionId' | translate"
                      optionLabel="descripcion" autoWidth="false" [style]="{'width':'100%'}" [filter]="true">
          </p-dropdown>
        </p-iconField>
				<ng-container *ngIf="form.get('departamentoExpedicionId')?.invalid && form.get('departamentoExpedicionId')?.dirty">
					<app-form-group-error-message [control]="form.get('departamentoExpedicionId')"></app-form-group-error-message>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  " *ngIf="isOtroPaisExpedicion || isOtroDepartamentoExpedicion">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-map z-1"></p-inputIcon>
          <input pInputText formControlName="otroDepartamentoExpedicion"
                 [placeholder]="'components.app-authentication-manager.register-form.otroDepartamentoExpedicion' | translate"
                 id="otroDepartamentoExpedicion" type="text" class="w-full container-input"/>
        </p-iconField>
				<ng-container *ngIf="form.get('otroDepartamentoExpedicion')?.invalid && form.get('otroDepartamentoExpedicion')?.touched">
					<app-form-group-error-message [control]="form.get('otroDepartamentoExpedicion')"/>
				</ng-container>
			</div>

			<div class="field col-12 mb-4  " *ngIf="isMunicipioExpedicionIdVisible">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-map-marker z-1"></p-inputIcon>
          <p-dropdown [options]="municipios" formControlName="municipioExpedicionId" appendTo="body" class="container-dropdown-input"
                      [placeholder]="'components.app-authentication-manager.register-form.municipioExpedicionId' | translate"
                      optionLabel="descripcion" autoWidth="false" [style]="{'width':'100%'}" [filter]="true">
          </p-dropdown>
        </p-iconField>
				<ng-container *ngIf="form.get('municipioExpedicionId')?.invalid && form.get('municipioExpedicionId')?.dirty">
					<app-form-group-error-message [control]="form.get('municipioExpedicionId')"/>
				</ng-container>
			</div>
			<div class="field col-12 mb-4  " *ngIf="isOtroPaisExpedicion || isOtroDepartamentoExpedicion || isOtroMunicipioExpedicion">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-map-marker z-1"></p-inputIcon>
          <input pInputText formControlName="otroMunicipioExpedicion"
                 [placeholder]="'components.app-authentication-manager.register-form.otroMunicipioExpedicion' | translate"
                 id="otroMunicipioExpedicion" type="text" class=" w-full container-input"/>
        </p-iconField>
				<ng-container *ngIf="form.get('otroMunicipioExpedicion')?.invalid && form.get('otroMunicipioExpedicion')?.touched">
					<app-form-group-error-message [control]="form.get('otroMunicipioExpedicion')"/>
				</ng-container>
			</div>

			<div class="field col-12 mb-4  ">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-calendar z-1"></p-inputIcon>
				<p-calendar id="fechaExpedicion" inputStyleClass="container-input"
                    [placeholder]="'components.app-authentication-manager.register-form.fechaExpedicion' | translate"
                    formControlName="fechaExpedicion">
        </p-calendar>
        </p-iconField>
				<ng-container *ngIf="form.get('fechaExpedicion')?.invalid && form.get('fechaExpedicion')?.touched">
					<app-form-group-error-message [control]="form.get('fechaExpedicion')"></app-form-group-error-message>
				</ng-container>
			</div>
			<div class="col-12">
		<!--		<label class="label-form-sidebar">
					{{"common.documento" | translate}}:<span style="color: red">*</span>
				</label>-->
				<div class="flex flex-wrap gap-1">
					<div class="flex flex-column">
						<div class="flex">
							<p-fileUpload #fileUpload mode="basic" accept="application/pdf" [maxFileSize]="uploadFileSize"
								[chooseLabel]="'form.button.agregar-documento' | translate" [customUpload]="true" [auto]="true" class=""
								(uploadHandler)="uploadHandler($event, fileUpload)" chooseIcon="pi pi-upload"></p-fileUpload>
							<button pButton icon="pi pi-trash" class="p-button-cancel-fileupload cancel border-noround-left" (click)="removeFile()"
								[disabled]="!archivoCedula"></button>
						</div>
						<ng-container *ngIf="invalidSize">
							<small class="p-error block"> <strong>{{archivoCedula?.name}}</strong>: {{"form.msg.invalid-size" | translate}} </small>
						</ng-container>
						<ng-container *ngIf="requieredFile">
							<small class="p-error block">{{"form.msg.campo-requerido" | translate}}</small>
						</ng-container>
						<div *ngIf="archivoCedula">
							<p>{{"common.archivo" | translate}} " {{archivoCedula.name}} " {{"form.msg.was-uploaded" | translate}}</p>
						</div>
					</div>
				</div>
			</div>
      <div class="col-12 my-2">
        <a (click)="onBack()" class="cursor-pointer color-blue-2 underline">
          {{"form.button.atras" | translate }}</a>
      </div>
      <div class="col-12 flex justify-content-end mt-4 gap-3 ">

        <button pButton type="button" icon="pi pi-times"
                [label]="'components.app-authentication-manager.register-form.limpiar' | translate"
                class="border-round-lg w-12rem p-button-secondary "
                (click)="onLimpiarDatos()"></button>

        <button pButton type="submit" icon="pi pi-save"
                [label]="'components.app-authentication-manager.register-form.registrarme' | translate"
                class=" border-round-lg w-12rem"></button>
      </div>
		</main>
	</div>
</form>
<p-toast />
